var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paginations"},[_c('el-pagination',{attrs:{"current-page":_vm.pageData.page,"page-size":_vm.pageData.size,"page-sizes":[10, 20, 30, 50],"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pageData.total},on:{"size-change":_vm.sizeChange,"current-change":_vm.currentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }